import { create } from "zustand";

interface FilterState {
  filters: Record<string, any>;
  setFilters: (filters: FilterState["filters"]) => void;
  resetFilters: () => void;
}

const defaultFilters: FilterState["filters"] = {
  "employee.employeeNumber": { value: "", matchMode: "equals" },
  "employee.name": { value: "", matchMode: "contains" },
  kmValueCalculated: { value: "", matchMode: "equals" },
  status: { value: "", matchMode: "equals" },
};

export const useFilterTripsheetStore = create<FilterState>((set) => ({
  filters: defaultFilters,
  setFilters: (filters) => set({ filters }),
  resetFilters: () => set({ filters: defaultFilters }),
}));
